<div class="container" *ngIf="(this.loader$ | async)?.visible">
  <div>
    <h1 class="text-title-lg text-bold mb-lg">{{ (loader$ | async)?.title }}</h1>
    <!--<i nz-icon nzType="loading" nzTheme="outline" ></i>-->
    <div class="loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <!--<h4>{{ (loader$ | async)?.description }}</h4>-->
  </div>
</div>
